import React, { Dispatch, SetStateAction } from "react";
import { Modal, ModalBody } from "reactstrap"
import StatisticsBody from "./StatisticsBody";
import { PromotionCriteria } from "../../backoffice/dtos/promotions/promotionCriteria";
import { TimelineDefaultPromotionCriteria } from "../timeline/PromotionsTimelineBase";
import { Loading } from "../views/Loading";

export default function StatisticsModal(
    {
        promotionCriteria,
        showStatistics,
        setShowStatistics,
        setPromotionCriteria
    }: {
        promotionCriteria: PromotionCriteria
        showStatistics: boolean;
        setShowStatistics: Dispatch<SetStateAction<boolean>>;
        setPromotionCriteria: Dispatch<SetStateAction<PromotionCriteria>>; 
    }
) {
    return (
        <Modal isOpen={showStatistics} toggle={() => setShowStatistics(val => !val)} size='xl'>
            <ModalBody>
                <React.Suspense fallback={<Loading />}>
                    {
                        showStatistics &&
                        <StatisticsBody
                            promotionCriteria={promotionCriteria}
                            toggle={() => setShowStatistics(val => !val)}
                            setSelectedPromotionCriteria={setPromotionCriteria}
                            initialFilter={TimelineDefaultPromotionCriteria}
                        />
                    }
                </React.Suspense>
            </ModalBody>
        </Modal>
    )
}